<div class="progress-bar" id="line" data-cy="line">
  <div
    class="progress-bar--filled"
    [ngStyle]="{ transform: '' + translateAmount ? 'translateX(' + translateAmount + '%)' : 'translateX(-100%)' }"
  ></div>
  <ng-template ngFor let-step [ngForOf]="stepOrder" let-index="index">
    <div
      class="progress-bar__line"
      [ngClass]="index <= (currentIndex$ | async) || isCompleted ? 'checked' : 'not-checked'"
      [attr.data-cy]="'line-step-' + index"
    ></div>
  </ng-template>
</div>
